import { render } from "./BaseimageLoader.vue?vue&type=template&id=4492ab1e&scoped=true"
const script = {}

import "./BaseimageLoader.vue?vue&type=style&index=0&id=4492ab1e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4492ab1e"]])

export default __exports__